import React from 'react';
import uniqid from 'uniqid';
import PropTypes from 'prop-types';
import cn from 'classnames';
import PopOver from 'chameleon/ui-stack/ui/base/popover';
import SPPProgressBar from './SPPProgressBar';
import SPPProgressDetails from './SPPProgressDetails';
import createStudentDetailsList from './spp-student-details/createStudentDetailsList';
import createStudentAnswerTipsDetails from './spp-student-details/createStudentAnswerTipsDetails';
import TextWithTooltip from 'chameleon/ui-stack/ui/assessments/text-with-tooltip';

const SPPProgressBarPopover = (props) => {
  const {
    isUnassigned,
    assignment,
    isActivePopover = true,
    fullWidth = false,
    hideTooltip = false,
    fromTeacherAssignmentsTable = false,
    forPartsAndTips = false,
    item = {},
    size,
  } = props;
  let { students } = props;
  const { studentsNotStarted, studentsNotSubmitted, studentsSubmitted } = item;

  const {
    sub_group_students: subGroupStudents,
    students_who_submitted_spp: submittedStudents,
    report,
  } = assignment || {};

  if ((subGroupStudents || []).length > 0) {
    students = students.filter(({ id: userId }) =>
      subGroupStudents.includes(userId),
    );
  }

  const totalStudents = students.length;

  const {
    studentsWhoHaveNotStarted,
    studentsWhoHaveNotSubmitted,
    studentsWhoHaveSubmitted,
  } = forPartsAndTips
    ? createStudentAnswerTipsDetails(
        studentsNotStarted,
        studentsNotSubmitted,
        studentsSubmitted,
        forPartsAndTips,
      )
    : createStudentDetailsList(students, report, submittedStudents);

  const totalSubmitted = studentsWhoHaveSubmitted.length;
  const started = studentsWhoHaveNotSubmitted.length;
  const notStarted = studentsWhoHaveNotStarted.length;

  const progressBarProgress = {
    totalStudents,
    totalSubmitted,
    started,
    notStarted,
  };

  const popoverDetails = {
    studentsWhoHaveNotStarted,
    studentsWhoHaveNotSubmitted,
    studentsWhoHaveSubmitted,
  };

  const hasProgress = totalStudents - notStarted > 0;
  const hasPopOver = hasProgress && isActivePopover;

  const tooltipTargetId = `tooltip-spp-progress-performance-popover-${uniqid()}`;
  const popOverContentId = `spp-progress-performance-popover-${uniqid()}`;
  const ariaLabel = `Open Student Practice Progress details: Not Started: ${notStarted} , Not Submitted: ${started}, Submitted: ${totalSubmitted}`;
  const progressBar = (
    <SPPProgressBar
      id={tooltipTargetId}
      active
      progress={progressBarProgress}
      isUnassigned={isUnassigned}
      fullWidth={fullWidth}
    />
  );
  const progressBarWithTooltip = (
    <TextWithTooltip
      target={hasProgress ? tooltipTargetId : ''}
      ariaLabel={hasProgress ? 'View Student Progress' : ''}
      tooltip={hasProgress ? 'View Student Progress' : ''}
      containerClassName={cn({ 'w-full': fullWidth })}
    >
      {progressBar}
    </TextWithTooltip>
  );

  return hasPopOver ? (
    <PopOver
      showCloseButton
      size={size}
      buttonClassName={fullWidth ? 'w-full' : ''}
      className={cn('progress_details_popover popover_underneath', {
        'w-full': fullWidth,
      })}
      accessibility={{
        'aria-label': ariaLabel,
        'aria-describedby': popOverContentId,
      }}
      popoverStyles={fullWidth ? { maxWidth: '100%' } : { maxWidth: '600px' }}
      trigger={hideTooltip ? progressBar : progressBarWithTooltip}
      {...props}
    >
      <SPPProgressDetails
        progressDetailsId={popOverContentId}
        popoverDetails={popoverDetails}
        assignment={assignment}
        fromTeacherAssignmentsTable={fromTeacherAssignmentsTable}
      />
    </PopOver>
  ) : (
    <SPPProgressBar
      active={false}
      progress={progressBarProgress}
      isUnassigned={isUnassigned}
      fullWidth={fullWidth}
    />
  );
};

SPPProgressBarPopover.displayName = 'SPPProgressBarPopover';
SPPProgressBarPopover.defaultProps = {
  progress: {},
  size: 'full',
};
SPPProgressBar.propTypes = {
  progress: PropTypes.shape({
    not_started: PropTypes.number,
    started: PropTypes.number,
    watched: PropTypes.number,
    total_students: PropTypes.number,
  }),
  size: PropTypes.string,
};
export default SPPProgressBarPopover;
